import type { Handler, NextFn, RequestContext } from '@ember-data/request';
import { modelNameForType } from 'scaleflow/services/data-socket';

type Ref = { type: string; id: string };
type Resource = Ref & {
  relationships?: Record<string, { data?: Ref | Ref[] | null }>;
};
type Document = { data?: Resource | Resource[] | null; included?: Resource[] };

const normalizeRef = (ref: Ref) => {
  ref.type = modelNameForType(ref.type);
};

const normalizeResource = (resource: Resource) => {
  normalizeRef(resource);
  for (const { data } of Object.values(resource.relationships ?? {})) {
    if (Array.isArray(data)) data.forEach(normalizeRef);
    else if (data) normalizeRef(data);
  }
};

// The API sends types like `IDEA` and `COMMENT`, not model names. On legacy
// requests the serializer translates them; builder requests (`store.request`)
// have no serializer, so this does that one job before the cache sees them.
export default class ModelTypesHandler implements Handler {
  async request<T>(context: RequestContext, next: NextFn<T>) {
    const { content } = await next(context.request);
    const document = content as Document | null;
    if (!document) return content;
    const { data, included } = document;
    if (Array.isArray(data)) data.forEach(normalizeResource);
    else if (data) normalizeResource(data);
    included?.forEach(normalizeResource);
    return content;
  }
}
